"use strict";

var config = require("app/util/config/config");
var APICaller = require("./api-caller");

var api = new APICaller(config.app.rdStationIntegrationURL);

api.getStatus = function(completed, failed) {
  this.get("/status", {}, {
    success: function(response) {
      completed(response.body);
    },
    error: function(err) {
      failed();
    }
  });
};

api.deactivate = function(completed, failed) {
  this.post("/deactivation", {}, {
    success: function(response) {
      completed(response.body);
    },
    error: function(err) {
      failed();
    }
  });
}

api.updateSettings = function(params, completed, failed) {
  // Counting on the server not to redirect
  this.patch("/settings", params, {
    success: function(response) {
      completed(response.body);
    },
    error: function(err) {
      failed()
    }
  })
}

api.getEventIdentifiers = function(completed, failed) {
  this.get("/event_identifiers", {}, {
    success: function(response) {
      completed(response.body);
    },
    error: function(err) {
      failed();
    }
  });
}

module.exports = api;



// WEBPACK FOOTER //
// ./app/util/api/rd-station-integration.js